import { useSelector } from "react-redux";
import store from "../storeWire";
import {
    getProfileAccountInformation
} from "../store/slice/model/Profile";

export function useProfileStore() {
    const profile_account_information = useSelector((state) => state.entities.model_Profile.accountInformation)

    let data = {
        profile_account_information
    };
    let fetch = {
        get_profile_account_information: async () => {
            return await store.dispatch(getProfileAccountInformation())
        }
    };
    let set = {
    };
    return [data, fetch, set]
}